import api from "./api";

const feeService = {
  // Receipts CRUD
  getAll: (params = {}) => api.get("/fees/receipts", { params }),
  getById: (id) => api.get(`/fees/receipts/${id}`),
  create: (data) => api.post("/fees/receipts", data),
  update: (id, data) => api.put(`/fees/receipts/${id}`, data),
  remove: (id) => api.delete(`/fees/receipts/${id}`),

  // Reports & Statements
  getStudentSummary: (studentId) => api.get(`/fees/student/${studentId}`),
  getStudentMultiYearStatement: (studentId) =>
    api.get(`/fees/student/${studentId}/statement`),
  getPending: (params = {}) => api.get("/fees/pending", { params }),
  getMonthlyReport: (params = {}) =>
    api.get("/fees/monthly-report", { params }),
  getYearSummary: (academicYear, params = {}) =>
    api.get("/fees/year-summary", { params: { academicYear, ...params } }),
  getYearMonthlyBreakdown: (academicYear, params = {}) =>
    api.get("/fees/year-monthly-breakdown", { params: { academicYear, ...params } }),

  // Utility
  getNextReceiptNo: (academicYearId) =>
    api.get("/fees/next-receipt-no", { params: { academicYearId } }),
};

export default feeService;